<script>
import 'materialize-css'
import 'materialize-css/dist/css/materialize.min.css'
import '@material-design-icons/font';

import axios from 'axios'
import Breadcrumb from './Breadcrumb.vue'

import {VersionInfo} from '../api.js'

export default {
  components: {
    Breadcrumb
  },
  mounted: function() {
    this.api.query(VersionInfo).updated((result) => {
      this.version = result.version
      this.revision = result.revision
    });
  },
  created: function () {
    let self = this;
    axios.get('/api/info').then(function (response) {
      let appInfo = response.data.result;
      // self.version = appInfo.version;
      self.cert_authorities = appInfo.cert_authorities;
      self.weblink_port_min = appInfo.weblink_port_min;
      self.weblink_port_max = appInfo.weblink_port_max;
    }).catch(function (error) {
      alert(error.response.data.result);
    });

  },
  computed: {
    development() {
      return this.revision.indexOf('-') !== -1
    }
  },
  data: function() {
    return {
      cert_authorities: [],
      version: "NO-VERSION",
      revision: "",
      weblink_port_min: 0,
      weblink_port_max: 0,
    }
  },
  props: {
    layout: Object,
    api: Object,
    connected: Boolean,
  }
}
</script>
<template>
  <div style="display: flex; flex-direction: column; flex: 1 0 auto">
    <header>
      <nav>
        <div class="nav-wrapper blue-grey darken-2">
          <img src="../assets/brand.png"
            style="max-height: 100%; max-width: 100%; padding-left: .5rem; padding-right: .5rem">
            <router-link class="brand-logo" to="/">WEST</router-link>
            <ul class="right hide-on-small-and-down">
              <li><router-link to="/servers">Servers</router-link></li>
              <li><router-link to="/clients">Clients</router-link></li>
              <li><a class="pull-right"
                  href="https://evtgit.zebra.com/evt/west/blob/master/CHANGELOG.md"
                  target="_blank"
                  title="What's new in this version of WEST.">About</a></li>
            </ul>
          </div>
        </nav>
      </header>
      <main id="app" style="flex: 1 0 auto;">
        <div class="container" style="margin-top:1em">
          <breadcrumb></breadcrumb>
        <router-view v-bind:weblink_port_min="weblink_port_min"
          v-bind:weblink_port_max="weblink_port_max"
          v-bind:cert_authorities="cert_authorities" v-bind:api="api" :layout.sync="layout">
        </router-view>
      </div>
    </main>
    <footer class="page-footer blue-grey darken-2">
      <div class="container">
        <p>
          <strong>WEST v</strong><span id="west-version">{{version}}</span>
          <span v-if="development" class="development">{{revision}}</span>
          <span v-if="connected" class="api-connected"></span>
          <span v-if="!connected" class="api-disconnected"></span>
        </p>
        <p><em>Powered by EVT and Python.</em></p>
      </div>
      <div class="footer-copyright blue-grey darken-4">
        <div class="container">
          <a class="grey-text text-lighten-4" href="https://www.zebra.com">2020 Zebra Technologies</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<style type="text/css" scoped>
.development::before {
  content: "(dev: ";
}
.development::after {
  content: ")";
}
.development {
  color: orange;
  margin-left: 1em;
}
.api-connected::before {
  margin-left:1em;
  content: "(connected)";
  color: green;
}
.api-disconnected::before {
  margin-left:1em;
  content: "(disconnected)";
  color: red;
}

body {
	display: flex;
	min-height: 100vh;
	flex-direction: column;
}
</style>
